module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_11_00_105Z.46563e19.png";